export default __webpack_public_path__ + "static/media/ruined_honey.6767fae1.png";